//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as api from "../api/api";
    import wechat from "../utils/wx";

    export default {
        data() {
            return {
                back: "<返回文章列表",
                readmore: "相关阅读>>",
                detailData: null,
                img: "https://huiyuanxitong.oss-cn-hangzhou.aliyuncs.com/dhy/opportunity/bg2.png",
                qrImg: "",
                backgroundStyle: "",
                hasSettingBackground: false
            };
        },
        mounted() {
            this.$emit("header");
            this.$emit("footer", false);

            if (this.$route.params.bac) {
                this.hasSettingBackground = true;
                this.backgroundStyle = `padding-top:0 !important;height: 1rem;`;
                this.img = this.$route.params.bac;
            }
            if (this.$route.params.qr) {
                this.qrImg = this.$route.params.qr;
            }

            this.$ajax.get(api.weixin, {
                params: {
                    signurl: location.href.split("#")[0],
                },
            }).then((res) => {
                this.wechatExist(function () {
                    let share = wechat(wx);
                    share.ready(
                        void 0,
                        {
                            link: location.href, // 分享链接
                            type: "", // 分享类型,music、video或link，不填默认为link
                            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                        },
                        {
                            page: "",
                            id: "",
                        }
                    );

                    share.config(res["wx"]);
                });
            });
        },
        beforeDestroy() {
            this.$emit("footer", false);
        },
        watch: {
            $route: function (to, from) {
                this.$mount();
            },
        },
        methods: {
            wechatExist(cb) {
                let timer = null;
                timer = setInterval(() => {
                    if ("wx" in window) {
                        clearInterval(timer);
                        if (cb) {
                            cb();
                        }
                    }
                }, 200);
            },
        },
    };



// WEBPACK FOOTER //
// ./src/components/new-result.vue